import { Icon } from "@iconify/react";
import Dashboard from "./Dashboard";
import Apps from "./Apps";
import AppDetailPage from "./Apps/DetailPage";
import AppRequests from "./AppRequests";
import Support from "./Support";
import { SocketProvider } from "../../context/socket";

const routes = [
  {
    title: "Dashboard",
    icon: <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />,
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    title: "Apps",
    icon: <Icon icon="mdi:apps" className="menu-icon" />,
    key: "apps",
    route: "/apps",
    component: <Apps />,
  },
  {
    key: "app_detail_page",
    route: "/apps/:id",
    component: <AppDetailPage />,
  },
  {
    title: "App Requests",
    icon: <Icon icon="mdi:clipboard-list-outline" className="menu-icon" />,
    key: "app_requests",
    route: "/app_requests",
    component: <AppRequests />,
  },
  {
    title: "Support",
    icon: <Icon icon="mdi:headset" className="menu-icon" />,
    key: "support",
    route: "/support",
    component: (
      <SocketProvider>
        <Support />
      </SocketProvider>
    ),
  },
];

export default routes;
